import React, { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import ApiTour from "../../../../../../API/ApiTour";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  Grid,
  FormControlLabel,
  MenuItem,
  Select,
  Typography,
  Box,
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import ApiUser from "../../../../../../API/ApiUser";
import { useTranslation } from "react-i18next";
import { withStyles } from "@material-ui/core/styles";

import styles from "./newCodeDialogStyles";

const NewCodeDialog = ({
  open,
  handleClose,
  tourId,
  classes,
  userLanguage,
}) => {
  const { t } = useTranslation();

  console.log("userLanguage : ", userLanguage);

  const [form, setForm] = useState({
    isAdmin: false,
    lastName: "",
    firstName: "",
    teamName: "",
    email: "",
    phoneNumber: "",
    usageLimitHours: "",
    maxNumberOfUsages: "",
    isTest: false,
    unlimitedUsages: false,
    isStoreGame: false,
    androidProductId: null,
    iosProductId: null,
    tourLanguage: null,
    userLanguage: userLanguage?.startsWith("fr") ? "fr" : "en",
  });

  useEffect(() => {
    setStateIsAdmin();
  }, []);

  useEffect(() => {
    setLanguage();
  }, [userLanguage]);

  const handleChange = (e) => {
    const { name, type } = e.target;
    const value = type === "checkbox" ? e.target.checked : e.target.value;

    setForm((prevForm) => ({ ...prevForm, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await ApiTour.newGuestUserTourCode({ ...form, tourId });
      setForm({
        lastName: "",
        firstName: "",
        teamName: "",
        email: "",
        phoneNumber: "",
        usageLimitHours: "",
        maxNumberOfUsages: "",
        isTest: false,
        unlimitedUsages: false,
        isStoreGame: false,
        androidProductId: null,
        iosProductId: null,
        tourLanguage: null,
        userLanguage: userLanguage?.startsWith("fr") ? "fr" : "en",
      });
      handleClose();
    } catch (error) {
      console.error("Erreur lors de l'envoi du formulaire :", error);
    }
  };

  const setLanguage = () => {
    setForm((prevForm) => ({
      ...prevForm,
      userLanguage: userLanguage?.startsWith("fr") ? "fr" : "en",
    }));
  };

  const setStateIsAdmin = async () => {
    let response = await ApiUser.isAdmin();

    if (response.status == 200) {
      setForm({
        isAdmin: response.data.isAdmin,
        lastName: "",
        firstName: "",
        teamName: "",
        email: "",
        phoneNumber: "",
        usageLimitHours: "",
        maxNumberOfUsages: "",
        isTest: false,
        unlimitedUsages: false,
        isStoreGame: false,
        androidProductId: null,
        iosProductId: null,
        tourLanguage: null,
        userLanguage: userLanguage?.startsWith("fr") ? "fr" : "en",
      });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className={classes.dialog}
      BackdropProps={{
        style: {
          backgroundColor: "rgba(0, 0, 0, 0.7)",
        },
      }}
    >
      <DialogTitle className={classes.dialogTitle}>
        {t("new_code_dialog.title")}
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <form onSubmit={handleSubmit} className={classes.form}>
          <TextField
            margin="dense"
            name="firstName"
            label={t("new_code_dialog.first_name")}
            type="text"
            fullWidth
            required
            onChange={handleChange}
            className={classes.textField}
            InputLabelProps={{
              className: classes.inputLabel,
            }}
            InputProps={{
              className: classes.input,
            }}
          />
          <TextField
            margin="dense"
            name="lastName"
            label={t("new_code_dialog.last_name")}
            type="text"
            fullWidth
            required
            onChange={handleChange}
            className={classes.textField}
            InputLabelProps={{
              className: classes.inputLabel,
            }}
            InputProps={{
              className: classes.input,
            }}
          />
          <TextField
            margin="dense"
            name="teamName"
            label={t("new_code_dialog.team_name")}
            type="text"
            fullWidth
            onChange={handleChange}
            className={classes.textField}
            InputLabelProps={{
              className: classes.inputLabel,
            }}
            InputProps={{
              className: classes.input,
            }}
          />
          <TextField
            margin="dense"
            name="email"
            label={t("new_code_dialog.email")}
            type="email"
            fullWidth
            onChange={handleChange}
            className={classes.textField}
            InputLabelProps={{
              className: classes.inputLabel,
            }}
            InputProps={{
              className: classes.input,
            }}
          />
          <TextField
            margin="dense"
            name="phoneNumber"
            label={t("new_code_dialog.phone")}
            type="tel"
            fullWidth
            onChange={handleChange}
            className={classes.textField}
            InputLabelProps={{
              className: classes.inputLabel,
            }}
            InputProps={{
              className: classes.input,
            }}
          />
          <Accordion className={classes.accordion}>
            <AccordionSummary
              expandIcon={<ExpandMore style={{ color: "white" }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>{t("new_code_dialog.more_options")}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2}>
                <Grid item sm={12} md={6}>
                  <TextField
                    margin="dense"
                    name="maxNumberOfUsages"
                    label={t("new_code_dialog.max_usages")}
                    type="number"
                    inputProps={{
                      min: 1,
                      max: 9999,
                    }}
                    fullWidth
                    onChange={handleChange}
                    className={classes.textField}
                    InputLabelProps={{
                      className: classes.inputLabel,
                    }}
                    InputProps={{
                      className: classes.input,
                    }}
                  />
                </Grid>
                <Grid item sm={12} md={6}>
                  <TextField
                    margin="dense"
                    name="usageLimitHours"
                    label={t("new_code_dialog.time_before_deactivation")}
                    type="number"
                    inputProps={{
                      min: 1,
                      max: 9999,
                    }}
                    fullWidth
                    onChange={handleChange}
                    className={classes.textField}
                    InputLabelProps={{
                      className: classes.inputLabel,
                    }}
                    InputProps={{
                      className: classes.input,
                    }}
                  />
                  <Typography className={classes.helperText}>
                    {t("new_code_dialog.time_before_expiration")}
                  </Typography>
                </Grid>
                <Grid item sm={12} md={6}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="unlimitedUsages"
                        checked={form.unlimitedUsages}
                        onChange={handleChange}
                        className={classes.checkbox}
                      />
                    }
                    label={t("new_code_dialog.unlimited_usages")}
                    className={classes.checkboxLabel}
                  />
                  <Typography className={classes.helperText}>
                    {t("new_code_dialog.unlimited_usages_info")}
                  </Typography>
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="isTest"
                        checked={form.isTest}
                        onChange={handleChange}
                        className={classes.checkbox}
                      />
                    }
                    label={t("new_code_dialog.test_code")}
                    className={classes.checkboxLabel}
                  />
                  {form.isTest && (
                    <Typography className={classes.warningText}>
                      {t("new_code_dialog.test_warning")}
                    </Typography>
                  )}
                  <Typography className={classes.helperText}>
                    {t("new_code_dialog.test_info")}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  {userLanguage && (
                    <Box className={classes.selectContainer}>
                      <Select
                        name="userLanguage"
                        id="select-language"
                        defaultValue={
                          userLanguage.startsWith("fr") ? "fr" : "en"
                        }
                        onChange={handleChange}
                        className={classes.select}
                      >
                        <MenuItem value="fr" className={classes.menuItem}>
                          {t("new_code_dialog.languages.fr")}
                        </MenuItem>
                        <MenuItem value="en" className={classes.menuItem}>
                          {t("new_code_dialog.languages.en")}
                        </MenuItem>
                      </Select>
                      <Typography className={classes.helperText}>
                        {t("new_code_dialog.select_language_info")}
                      </Typography>
                    </Box>
                  )}
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>

          {form.isAdmin && (
            <Box mt={2}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="isStoreGame"
                    checked={form.isStoreGame}
                    onChange={handleChange}
                    className={classes.checkbox}
                  />
                }
                label={t("new_code_dialog.store_game")}
                className={classes.checkboxLabel}
              />
              {form.isStoreGame && (
                <Box mt={2}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        margin="dense"
                        name="androidProductId"
                        label={t("new_code_dialog.android_product_id")}
                        type="text"
                        fullWidth
                        onChange={handleChange}
                        className={classes.textField}
                        InputLabelProps={{
                          className: classes.inputLabel,
                        }}
                        InputProps={{
                          className: classes.input,
                        }}
                      />
                      <Typography className={classes.helperText}>
                        {t("new_code_dialog.leave_empty_if_free")}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        margin="dense"
                        name="iosProductId"
                        label={t("new_code_dialog.ios_product_id")}
                        type="text"
                        fullWidth
                        onChange={handleChange}
                        className={classes.textField}
                        InputLabelProps={{
                          className: classes.inputLabel,
                        }}
                        InputProps={{
                          className: classes.input,
                        }}
                      />
                      <Typography className={classes.helperText}>
                        {t("new_code_dialog.leave_empty_if_free")}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Box className={classes.selectContainer}>
                        <Select
                          name="tourLanguage"
                          id="select-language"
                          defaultValue="fr"
                          onChange={handleChange}
                          className={classes.select}
                        >
                          <MenuItem value="fr" className={classes.menuItem}>
                            {t("new_code_dialog.languages.fr")}
                          </MenuItem>
                          <MenuItem value="en" className={classes.menuItem}>
                            {t("new_code_dialog.languages.en")}
                          </MenuItem>
                          <MenuItem value="al" className={classes.menuItem}>
                            {t("new_code_dialog.languages.al")}
                          </MenuItem>
                          <MenuItem value="es" className={classes.menuItem}>
                            {t("new_code_dialog.languages.es")}
                          </MenuItem>
                          <MenuItem value="it" className={classes.menuItem}>
                            {t("new_code_dialog.languages.it")}
                          </MenuItem>
                        </Select>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              )}
            </Box>
          )}

          <DialogActions className={classes.dialogActions}>
            <Button onClick={handleClose} className={classes.cancelButton}>
              {t("new_code_dialog.cancel")}
            </Button>
            <Button type="submit" className={classes.submitButton}>
              {t("new_code_dialog.add")}
            </Button>
          </DialogActions>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default withStyles(styles)(NewCodeDialog);
